module.exports = __webpack_public_path__ + "static/media/galerija_2019 (38).271cf739.jpg";